import { Box } from '@mui/material';
import { RenderTable } from '../../../../../components/ui';
import TBody from './TBody';
// import TFoot from './TFoot';
import THead from './THead';
import { useState } from 'react';
interface IProps {
  moduleData: any;
  tabValue: number;
  isView: boolean;
  machineData?: any;
  vedorData?: any;
}

const TController = ({
  moduleData,
  tabValue,
  isView,
  machineData,
  vedorData,
}: IProps) => {
  const [dateRender, setDateRender] = useState(false);

  return (
    <Box>
      <RenderTable>
        <THead {...{ moduleData, tabValue, isView, setDateRender }} />
        <TBody {...{ moduleData, tabValue, isView, machineData, vedorData }} />

        {/* <TFoot
          preparedBy={moduleData.report_prepared_by}
          approvedBy={moduleData.report_approved_by}
        /> */}
      </RenderTable>
    </Box>
  );
};

export default TController;
